

export default class Widget {


    constructor(controllerData) {

        // Status
        this.loading = false;
        this.error = false;

        // Options selection
        this.current = 0 ;
        this.options = controllerData.options ?  controllerData.options : [];
        this.url = controllerData.url;
        //this.height = controllerData.height; // TODO Used???
        //this.width = controllerData.width;
        //this.title = controllerData.title;

        // Datas is also cache
        if(this.options.length){
            this.datas = this.options.map(() => null);
        } else {
            this.datas = [null];
        }

    }


    async load(option = 0){

        if(option < 0 || option >= this.datas.length){
            throw "Invalid Widget option";
        }

        this.current = option;

        if(this.datas[this.option]){
            return true;
        }

        this.loading = true;
        this.error = false;

        const data = {
            option: this.current
        };

        try {
            const response = await axios.post('/dashboard/' + this.url, data);
            this.datas[this.current] = response.data;

            this.loading = false;
            return true;
        } catch (e) {
            console.log(e);
            this.loading = false;
            this.error = true;
            return false;
        }

    }


    data(option = null){

        if(option === null) option = this.current;

        if(option < 0 || option >= this.datas.length){
            throw "Invalid Widget option";
        }

        return this.datas[option];

    }




}